const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
};
export function createApiClient(options) {
    const { baseUrl, getToken, onUnauthorized } = options;
    async function request(path, opts = {}) {
        const url = `${baseUrl}${path}`;
        const headers = { ...DEFAULT_HEADERS, ...opts.headers };
        const token = getToken?.();
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        const response = await fetch(url, {
            method: opts.method || 'GET',
            headers,
            body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
        });
        if (response.status === 401) {
            onUnauthorized?.();
            throw new ApiError(response.status, 'Unauthorized');
        }
        if (!response.ok) {
            let detail = '';
            try {
                const err = await response.json();
                detail = err.message || err.title || JSON.stringify(err);
            }
            catch {
                detail = await response.text();
            }
            throw new ApiError(response.status, detail || response.statusText);
        }
        if (response.status === 204) {
            return undefined;
        }
        return response.json();
    }
    return {
        get: (path) => request(path),
        post: (path, body) => request(path, { method: 'POST', body }),
        put: (path, body) => request(path, { method: 'PUT', body }),
        delete: (path) => request(path, { method: 'DELETE' }),
    };
}
export class ApiError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = 'ApiError';
    }
}
